import { useMutation } from "@apollo/client/react";
import { useState, useCallback, useMemo, useRef, useEffect } from "react";

export const useSeleccionLiquidaciones = () => {
    // Set<idProfesionalLiquidacion>
    const [seleccionados, setSeleccionados] = useState(() => new Set());

    const seleccionRef = useRef(seleccionados);
    useEffect(() => {
        seleccionRef.current = seleccionados;
    }, [seleccionados]);

    const toggleSeleccion = useCallback((idProfesionalLiquidacion) => {
        setSeleccionados(prev => {
            const next = new Set(prev);
            if (next.has(idProfesionalLiquidacion)) {
                next.delete(idProfesionalLiquidacion);
            } else {
                next.add(idProfesionalLiquidacion);
            }
            return next;
        });
    }, []);

    const seleccionarTodos = useCallback((idProfesionalLiquidacion) => {
        // Ahora seleccionarTodos es toggleSeleccion para el header
        toggleSeleccion(idProfesionalLiquidacion);
    }, [toggleSeleccion]);

    const limpiarSeleccion = useCallback(() => {
        setSeleccionados(new Set());
    }, []);

    const cantidadSeleccionada = useMemo(() => seleccionados.size, [seleccionados]);

    return {
        toggleSeleccion,
        seleccionarTodos,
        limpiarSeleccion,
        cantidadSeleccionada,
        seleccionados
    };
};